import axf from 'axf-polyfill';

// axf-polyfill
window.a = window.axf = axf;
